// /app/frontend/src/lib/fetchTimezone.js
// Wrap window.fetch once to inject X-User-Timezone header on every backend call.

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const getTz = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
};

let installed = false;

export const installFetchTimezone = () => {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  const original = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    try {
      const url = typeof input === 'string' ? input : input?.url || '';
      // Only inject for our backend
      if (API_BASE && url.startsWith(API_BASE)) {
        const headers = new Headers(init.headers || {});
        if (!headers.has('X-User-Timezone')) {
          headers.set('X-User-Timezone', getTz());
        }
        init = { ...init, headers };
      }
    } catch {
      // ignore — fall through to original fetch
    }
    return original(input, init);
  };
};
